<template>
  <div>
    <v-card color="grey lighten-1 white--text">
      <v-layout align-center row>
        <v-flex xs1 md1 pl-4>Icon</v-flex>
        <v-flex xs2 md2 pl-3>Name</v-flex>
        <v-flex xs3 md4>Description</v-flex>
        <v-flex xs3 md2>Point Threshold</v-flex>
        <v-flex xs2 md2>Multiplier Percentage</v-flex>
        <v-flex xs1 md1 pr-4>
          <v-layout justify-end>Edit</v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card
      v-for="loyaltyTier in loyaltyTiers"
      :key="loyaltyTier.id"
      :color="loyaltyTier.enabled ? 'white' : 'grey lighten-2'"
    >
      <v-layout align-center row>
        <v-flex xs1 md1 pl-2 pt-1 pb-1>
          <v-avatar color="grey lighten-4" :size="64">
            <img :src="loyaltyTier.picture" />
          </v-avatar>
        </v-flex>
        <v-flex xs2 md2>
          <v-card-title>
            <h4>{{loyaltyTier.name}}</h4>
          </v-card-title>
        </v-flex>
        <v-flex xs3 md4>{{ loyaltyTier.description }}</v-flex>
        <v-flex xs3 md2>{{loyaltyTier.point_threshold}}</v-flex>
        <v-flex xs2 md2>{{loyaltyTier.multiplier_percentage}}</v-flex>
        <v-flex xs1 md1 pr-2>
          <v-layout justify-end>
            <v-card-actions>
              <v-btn icon ripple @click="edit(loyaltyTier.id)">
                <v-icon color="grey lighten-1">edit</v-icon>
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "loyalty_tier_list",
  components: {},
  props: {
    loyaltyTiers: Array,
    loading: Boolean,
    loadingCostEstimates: Boolean
  },
  beforeMount: async function() {
    this.rideTypesStore = this.ride_types;
  },
  methods: {
    edit: function(id) {
      this.$emit("edit", id);
    }
  }
};
</script>
